export const PAPELDEFAULT = '00000';
export const PAPEL1 = '10000'; // visualização
export const PAPEL2 = '21430'; // gestão
export const PAPEL3 = '43334'; // administração
export const PAPEL4 = '44444'; // super admin
export const PAPEL5 = '43344'; // administração wl
export const PAPEL6 = '21000'; // subgestão
export const PAPEL7 = '44333'; // integração
export const PAPEL8 = '44433'; // replicação
export const PAPEL9 = '44443'; // comercial

/* display name usuarios */
export const GESTAO = 'Gestão';
export const ADMINISTRACAO = 'Administração';
export const VISUALIZACAO = 'Visualização';
export const SUPERADMIN = 'Super Admin';
export const ADMINISTRACAOWL = 'Administração WL';
export const SUBGESTAO = 'Subgestão';
export const INTEGRACAO = 'Integração';
export const REPLICACAO = 'Replicação';
export const COMERCIAL = 'Comercial';

